import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    fetchAdministrationGroupe,
    fetchAdministrationActionsNonGeneriques,
    fetchAdministrationGroupesSecurite,
    fetchAdministrationMotifsResolution,
    fetchAdministrationCausesPrincipales
} from 'store/administration/administrationActions';

import { patchGroupe } from 'store/administration/administrationActions';
import { clearUtilisateurValue } from 'store/utilisateur/utilisateursActions';
import AdministrationGroupe from './AdministrationGroupe';
import withLoader from 'components/Shared/withLoader';

const AdministrationGroupeWithLoader = withLoader(AdministrationGroupe);

class AdministrationGroupeContainer extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            groupe: null,
            utilisateur: null,
            actionsIds: null,
            actions: null,
            groupeSecuriteId: '',

            motifsResolutionIds: null,
            motifsResolution: null,

            causesPrincipalesIds: null,
            causesPrincipales: null
        };
    }

    async componentDidMount() {
        const { id } = this.props;

        await this.props.fetchAdministrationGroupe(id);
        await this.props.fetchAdministrationActionsNonGeneriques();
        await this.props.fetchAdministrationGroupesSecurite();

        await this.props.fetchAdministrationMotifsResolution({ avecNbActions: false });
        await this.props.fetchAdministrationCausesPrincipales({ avecNbActions: false });

    }


    componentDidUpdate(prevProps) {
        let { id, isLoading, groupes } = this.props;

        if (prevProps.isLoading && !isLoading) {

            let groupe = groupes.find(x => x.id === id);

            let actionsIds = groupe.actions.map(x => x.id);
            let actions = this.props.actionsNonGeneriques.filter(x => !actionsIds.includes(x.id));

            let motifsResolutionIds = groupe.motifsResolution.sort((a, b) => a.position - b.position).map(x => x.id);
            let motifsResolution = this.props.motifsResolution.filter(x => !motifsResolutionIds.includes(x.id));

            let causesPrincipalesIds = groupe.causesPrincipales.sort((a, b) => a.position - b.position).map(x => x.id);
            let causesPrincipales = this.props.causesPrincipales.filter(x => !causesPrincipalesIds.includes(x.id));


            this.setState({
                groupe: JSON.parse(JSON.stringify(groupe)),
                actionsIds: actionsIds,
                actions: actions,
                motifsResolutionIds: motifsResolutionIds,
                motifsResolution: motifsResolution,
                causesPrincipalesIds: causesPrincipalesIds,
                causesPrincipales: causesPrincipales
            });
        }
    }


    handleDrop = (actionsIds) => {
        this.setState({
            ...this.state,
            actionsIds: actionsIds
        });
    };

    handleDropMotifResolution = (motifsResolutionIds) => {
        this.setState({
            ...this.state,
            motifsResolutionIds: motifsResolutionIds
        });
    };

    handleDropCausePrincipale = (causesPrincipalesIds) => {
        this.setState({
            ...this.state,
            causesPrincipalesIds: causesPrincipalesIds
        });
    };


    handleChange = (event) => {
        let newGroupe = this.state.groupe;

        if (event.target.name === 'libelle') {
            newGroupe.libelle = event.target.value;
        }

        if (event.target.name === 'initiales') {
            newGroupe.initiales = event.target.value;
        }

        if (event.target.name === 'actif') {
            newGroupe.actif = !newGroupe.actif;
        }

        if (event.target.name === 'visible') {
            newGroupe.visible = !newGroupe.visible;
        }

        if (event.target.name === 'autoriseCreationReclamationLiee') {
            newGroupe.autoriseCreationReclamationLiee = !newGroupe.autoriseCreationReclamationLiee;
        }

        if (event.target.name === 'autoriseSAV') {
            newGroupe.autoriseSAV = !newGroupe.autoriseSAV;
        }

        if (event.target.name === 'autoriseMemo') {
            newGroupe.autoriseMemo = !newGroupe.autoriseMemo;
        }

        if (event.target.name === 'notifierPilote') {
            newGroupe.notifierPilote = !newGroupe.notifierPilote;
        }

        if (event.target.name === 'notifierEmetteurReclamation') {
            newGroupe.notifierEmetteurReclamation = !newGroupe.notifierEmetteurReclamation;
        }

        this.setState({ ...this.state, groupe: newGroupe });
    };

    handleClickDeletePilote = (event, id) => {
        let newGroupe = this.state.groupe;

        newGroupe.pilotes = newGroupe.pilotes.filter(x => x.id !== id);

        this.setState({ ...this.state, groupe: newGroupe });
    };

    handleClickDeleteGroupeSecurite = (event, id) => {
        let newGroupe = this.state.groupe;

        newGroupe.groupesSecurite = newGroupe.groupesSecurite.filter(x => x.id !== id);

        this.setState({ ...this.state, groupe: newGroupe });
    };

    handleChangeUtilisateur = (id, codePO, nom, prenom) => {
        this.setState({ ...this.state, utilisateur: { id, codePO, nom, prenom } });
    };

    handleClickAddPilote = () => {
        let newGroupe = this.state.groupe;
        let utilisateur = this.state.utilisateur;
        newGroupe.pilotes.push(utilisateur);

        this.setState({ utilisateur: null, groupe: newGroupe });

        this.props.clearUtilisateurValue("administrationGroupes");
    };

    handleChangeGroupeSecurite = (event) => {
        this.setState({ ...this.state, groupeSecuriteId: event.target.value.toString() });
    };

    handleClickAddToAdmin = () => {
        let { groupesSecurite } = this.props;
        let { groupeSecuriteId, groupe } = this.state;

        let groupeSecurite = groupesSecurite.find(x => x.id === parseInt(groupeSecuriteId));

        let newGroupe = groupe;
        let newGroupeSecurite = { ...groupeSecurite, administrateur: true };
        newGroupe.groupesSecurite.push(newGroupeSecurite);

        this.setState({
            ...this.state,
            groupe: newGroupe,
            groupeSecuriteId: ''
        });
    };

    handleClickAddToMember = () => {
        let { groupesSecurite } = this.props;
        let { groupeSecuriteId, groupe } = this.state;

        let groupeSecurite = groupesSecurite.find(x => x.id === parseInt(groupeSecuriteId));

        let newGroupe = groupe;
        let newGroupeSecurite = { ...groupeSecurite, administrateur: false };
        newGroupe.groupesSecurite.push(newGroupeSecurite);

        this.setState({
            ...this.state,
            groupe: newGroupe,
            groupeSecuriteId: ''
        });
    };

    handleClickCancel = (event) => {
        this.setState({
            groupe: null
        });
        this.props.clearUtilisateurValue("administrationGroupes");
    };

    handleClickSave = (event, id) => {
        this.props.patchGroupe(this.state.groupe, this.state.actionsIds, this.state.motifsResolutionIds, this.state.causesPrincipalesIds);
        this.setState({
            groupe: null
        });
    };

    render() {
        const { isLoading, isPatching, groupes, groupesSecurite, motifsResolution, causesPrincipales } = this.props;
        const { groupe, utilisateur, actions, groupeSecuriteId } = this.state;

        let sauvegardable = !groupe || (groupe.libelle.length > 0 && groupe.initiales.length > 0);

        let addPiloteEnable = utilisateur && utilisateur.id !== 0;

        let groupesSecuriteDisponibles = groupe && groupe.groupesSecurite ? groupesSecurite.filter(x => undefined === groupe.groupesSecurite.find(y => y.id === x.id)) : [];

        let motifsResolutionDisponibles = groupe && groupe.motifsResolution ? motifsResolution.filter(x => undefined === groupe.motifsResolution.find(y => y.id === x.id)) : [];
        let causesPrincipalesDisponibles = groupe && groupe.causesPrincipales ? causesPrincipales.filter(x => undefined === groupe.causesPrincipales.find(y => y.id === x.id)) : [];


        return (
            <AdministrationGroupeWithLoader
                isLoading={isLoading}
                isPatching={isPatching}
                groupes={groupes}

                groupesSecurite={groupesSecuriteDisponibles}

                actionsNonGeneriques={actions}
                selectedGroupe={groupe}
                groupeSecuriteId={groupeSecuriteId}

                onChange={this.handleChange}
                onClickCancel={this.handleClickCancel}
                onClickSave={this.handleClickSave}
                onClickAddPilote={this.handleClickAddPilote}
                onClickDeletePilote={this.handleClickDeletePilote}
                onClickDeleteGroupeSecurite={this.handleClickDeleteGroupeSecurite}
                onChangeUtilisateur={this.handleChangeUtilisateur}

                onClickAddToAdmin={this.handleClickAddToAdmin}
                onClickAddToMember={this.handleClickAddToMember}

                onChangeGroupeSecurite={this.handleChangeGroupeSecurite}

                sauvegardable={sauvegardable}
                addPiloteEnable={addPiloteEnable}

                onDrop={this.handleDrop}
                onDropMotifResolution={this.handleDropMotifResolution}
                onDropCausePrincipale={this.handleDropCausePrincipale}

                motifsResolutionDisponibles={motifsResolutionDisponibles}
                causesPrincipalesDisponibles={causesPrincipalesDisponibles}
            />);
    }
}

AdministrationGroupeContainer.propTypes = {
    id: PropTypes.number
};

const mapStateToProps = state => ({
    isLoading: state.administration.groupes.isLoading || state.administration.groupesSecurite.isLoading || state.administration.actionsNonGeneriques.isLoading
        || state.administration.motifsResolution.isLoading || state.administration.causesPrincipales.isLoading,
    isPatching: state.administration.groupes.isPatching,
    groupes: state.administration.groupes.items,
    actionsNonGeneriques: state.administration.actionsNonGeneriques.items,
    groupesSecurite: state.administration.groupesSecurite.items,
    motifsResolution: state.administration.motifsResolution.items,
    causesPrincipales: state.administration.causesPrincipales.items
});

const mapDispatchToProps = dispatch => ({
    fetchAdministrationGroupe: (id) => dispatch(fetchAdministrationGroupe(id)),
    patchGroupe: (groupe, actionsIds, motifsResolutionIds, causesPrincipalesIds) => dispatch(patchGroupe(groupe, actionsIds, motifsResolutionIds, causesPrincipalesIds)),
    clearUtilisateurValue: (namespace) => dispatch(clearUtilisateurValue(namespace)),
    fetchAdministrationActionsNonGeneriques: () => dispatch(fetchAdministrationActionsNonGeneriques()),
    fetchAdministrationGroupesSecurite: () => dispatch(fetchAdministrationGroupesSecurite()),
    fetchAdministrationMotifsResolution: (param) => dispatch(fetchAdministrationMotifsResolution(param)),
    fetchAdministrationCausesPrincipales: (param) => dispatch(fetchAdministrationCausesPrincipales(param))
});

export default connect(mapStateToProps, mapDispatchToProps)(AdministrationGroupeContainer);